import React from 'react';
import styled, { css, useTheme } from 'styled-components';
import { Box, Text } from '@sparknz/spark-pattern-library';

import { useSegment } from 'shared/hooks';
import { GalleryProductWithPosition } from '../typings';
import {
  getPricePeriod,
  getPriceValueText,
  getSavingPriceText,
  getWasPriceText,
} from '../utils/getDeviceGalleryCardContent.utils';
import Tag from './Tag';

interface PriceProps {
  product: GalleryProductWithPosition;
}

const StyledText = styled(Text)`
  white-space: pre;
`;

const WasPriceText = styled(Text)`
  height: 24px;
  span {
    text-decoration: line-through;
  }
`;

const WasPriceTag = styled(Tag)`
  ${({ theme: { palette } }) => css`
    background: ${`${palette.baseColors.darkPink}16`};
  `}
`;
const ProductPrice: React.FC<PriceProps> = ({ product }) => {
  const {
    palette: { baseColors },
  } = useTheme();
  const { isBusiness } = useSegment();

  const wasPriceText = getWasPriceText(product, isBusiness);
  const savingPriceText = getSavingPriceText(product, isBusiness);
  const pricePeriod = getPricePeriod(product, isBusiness);
  const priceValue = getPriceValueText(product, isBusiness);

  const { displaySettings } = product;
  const { shouldShowWasPriceLine } = displaySettings;
  const shouldShowSavingTag = !!savingPriceText;

  const wasPriceElement = wasPriceText ? (
    <>
      Was <span>{wasPriceText}</span>
    </>
  ) : null;

  return (
    <>
      <Box flexDirection="column" alignItems="flex-start" justifyContent="end">
        <Box flexDirection="row" px="s4" alignItems="baseline">
          <Text variant="subheadingL" color={baseColors.newZealandBlack}>
            {priceValue}
          </Text>
          {pricePeriod ? (
            <StyledText
              variant="bodySMedium"
              color={baseColors.newZealandBlack}
            >
              {`/${pricePeriod}`}
            </StyledText>
          ) : null}
        </Box>

        {shouldShowSavingTag ? (
          <WasPriceTag position="absolute" px="s1" py="s1">
            <Text variant="bodySDemi" color={baseColors.darkPink}>
              Save {savingPriceText}
            </Text>
          </WasPriceTag>
        ) : null}
      </Box>
      <Box px="s4" flexDirection="row" gap="s1" mb="s1">
        {isBusiness ? (
          <StyledText variant="bodySMedium" color={baseColors.mawheranui}>
            (excl. GST)
          </StyledText>
        ) : null}
        {shouldShowWasPriceLine ? (
          <WasPriceText variant="bodySMedium" color={baseColors.mawheranui}>
            {wasPriceElement}
          </WasPriceText>
        ) : null}
      </Box>
    </>
  );
};

export default ProductPrice;
